module.exports = __webpack_public_path__ + "img/teeth-44.68691b4b.png";